export const Languages = ['de', 'en', 'fr', 'it'];
export let Language = Languages[0];

if (document.documentElement) {
    Language = (process.env.NODE_ENV === 'production') ? document.documentElement.lang : Languages[0];
}

export const NextLanguage = Languages.filter(l => l !== Language)[0];   


// WEBPACK FOOTER //
// ./src/utils/Languages.tsx